import { Linking, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { document_icon } from '../../../assets/base64';
import { FONTS } from '../../../constants';
import { IServiceForm } from '../../../types/services.types';

interface ServiceItemProps {
  item: IServiceForm;
}

const ServiceItem: FC<ServiceItemProps> = ({ item }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        if (item.attachment.url) {
          Linking.openURL(item.attachment.url);
        }
      }}
      style={{ flexDirection: 'column', alignItems: 'center' }}
    >
      <View
        style={{
          width: 60,
          height: 60,
          borderWidth: 1,
          borderRadius: 60,
          borderColor: STYLE_VARS.primaryColor,
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 10,
        }}
      >
        <Image
          source={
            IS_WEB
              ? addBase64Prefix(document_icon)
              : require('../../../assets/document-icon.png')
          }
          style={{
            width: 20,
            height: 30,
            resizeMode: 'contain',
            tintColor: STYLE_VARS.primaryColor,
          }}
        />
      </View>
      <View>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            color: STYLE_VARS.fccDarkerGrey,
            fontSize: 14,
            textAlign: 'center',
            textTransform: 'uppercase',
          }}
        >
          {item.title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default ServiceItem;

const styles = StyleSheet.create({});
